import { render, staticRenderFns } from "./register-success.vue?vue&type=template&id=7a0b41ef"
import script from "./register-success.vue?vue&type=script&lang=ts"
export * from "./register-success.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports